type HamburgerIconProps = {
  size?: number
}

export function HamburgerIcon({ size = 24 }: HamburgerIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M18.25 15.25C18.6642 15.25 19 15.5858 19 16C19 16.4142 18.6642 16.75 18.25 16.75H1.75C1.33579 16.75 1 16.4142 1 16C1 15.5858 1.33579 15.25 1.75 15.25H18.25Z" fill="currentColor" />
      <path d="M18.25 9.25C18.6642 9.25 19 9.58579 19 10C19 10.4142 18.6642 10.75 18.25 10.75H1.75C1.33579 10.75 1 10.4142 1 10C1 9.58579 1.33579 9.25 1.75 9.25H18.25Z" fill="currentColor" />
      <path d="M18.25 3.25C18.6642 3.25 19 3.58579 19 4C19 4.41421 18.6642 4.75 18.25 4.75H1.75C1.33579 4.75 1 4.41421 1 4C1 3.58579 1.33579 3.25 1.75 3.25H18.25Z" fill="currentColor" />
    </svg>
  )
}
